import { EntityId } from "@reduxjs/toolkit";
import { SelectedDeviceProperties } from "features/liveStreaming/types/SelectedDeviceProperties";
import { SessionOrigin } from "../types/UserSessionOrigin";

export interface SelectedDeviceDevice {
    deviceId: EntityId;
    properties: SelectedDeviceProperties;
}

export interface DeviceWithBadConnection {
    deviceId: EntityId;
    badNetworkDetectedTime: string;
}

export interface SiteDeviceSelection {
    siteId: EntityId;
    /**
     *  Ajv schema default value if not present
     *  @default false
     */
    deviceSelectionIsDoneByPaging: boolean;
    pageNumber: number;
    selectedDevices?: SelectedDeviceDevice[];
    /**
     *  Ajv schema default value if not present
     *  @default []
     */
    devicesWithBadConnection: DeviceWithBadConnection[];
}

export interface LiveStreamingState {
    activeSiteId?: EntityId;
    siteDeviceSelections?: SiteDeviceSelectionsList;
    fullscreenDeviceId?: EntityId;
    sessionOrigin: SessionOrigin;
    sessionOriginSiteId?: EntityId;
    sessionStartTime?: string;
}

export const initialState: LiveStreamingState = {
    activeSiteId: undefined,
    siteDeviceSelections: undefined,
    fullscreenDeviceId: undefined,
    sessionOrigin: "none",
    sessionOriginSiteId: undefined,
    sessionStartTime: undefined,
};

export type SiteDeviceSelectionsList = SiteDeviceSelection[];
